import React, { useEffect, useState } from "react";
import SkeletonTable from "../../../components/table/SkeletonTable.jsx";
import columns from "../../../columns/reviewTax/viewReviewTax.js";
import LoadableButton from "../../../components/buttons/LoadableButton";
import {
  GetOrganizerAnswerApi,
  CompleteReviewTaxApi,
  GetInvoiceListApi,
  SendInvoiceApi,
  ForceCompleteReviewTaxApi,
  DeleteInvoiceApi,
} from "../../../api/request/taskManager/taskManager.js";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Button, Form, Select, Spin } from "antd";
import PdfLink from "../../../components/common/PdfLink.jsx";
import Edit from "../../../assets/Edit.jsx";
import AnswerModal from "../../reviewDoc/components/AnswerModal.jsx";
import ViewFilesModal from "../../reviewDoc/components/ViewFilesModal.jsx";
import { getSocket } from "../../../services/Socket.js";
import ModalComponent from "../../../components/modals/ModalComponent.jsx";
import ConfirmationModal from "../../../components/modals/ConfirmationModal.jsx";

export default function ViewReviewTax() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const socket = getSocket();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [data, setData] = useState([]);
  const [clientData, setClientData] = useState({});
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [isAnswerOpen, setIsAnswerOpen] = useState(false);
  const [isFilesOpen, setIsFilesOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoadingInvoice, setIsLoadingInvoice] = useState(false);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [initialValues, setInitialValues] = useState({ invoice_temp_id: null });
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isForceCompleteLoading, setIsForceCompleteLoading] = useState(false);
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  const [isInvoiceLoading, setIsInvoiceLoading] = useState(false);

  const getAnswer = async () => {
    try {
      setIsLoading(true);
      let params = { organizer_id: id };
      const { data } = await GetOrganizerAnswerApi(params);
      if (data?.status) {
        setClientData(data?.client_selected_org);
        setData(
          data?.data?.map((section) => {
            return {
              ...section,
              questions: section?.questions?.map((question) => {
                return {
                  ...question,
                  response_text: (
                    <div className="flex items-center gap-3 max-w-[250px]">
                      {question?.response_text && (
                        <p className="text-wrap">{question?.response_text}</p>
                      )}
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setSelectedQuestion(question);
                          setIsAnswerOpen(true);
                        }}
                      >
                        <Edit />
                      </div>
                    </div>
                  ),
                  ...(question?.documents?.length && {
                    response_text: (
                      <a
                        onClick={() => {
                          setSelectedQuestion(question);
                          setIsFilesOpen(true);
                        }}
                        className="hover:text-primary text-primary underline underline-offset-4"
                        target="_blank"
                      >
                        View Files🔻
                      </a>
                    ),
                  }),
                  question: (
                    <div
                      className={`${
                        !question?.reviewed_checked
                          ? "font-semibold highlight-text"
                          : ""
                      }`}
                    >
                      {question?.field_label || "--"}
                    </div>
                  ),
                  review: (
                    <div>
                      <img
                        className="size-7"
                        src={
                          question?.reviewed_checked
                            ? "/assets/icons/outlined-check-circle.svg"
                            : "/assets/icons/outlined-circle.svg"
                        }
                      />
                    </div>
                  ),
                };
              }),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAnswer();
  }, []);

  const completeTask = async () => {
    try {
      setIsSubmitLoading(true);
      const { data } = await CompleteReviewTaxApi({ organizer_id: id });
      if (data?.status) {
        toast.success(data?.message);
        socket.emit(
          "updateTask",
          JSON.stringify({ task: 3, userId: clientData?.user_id })
        );
        navigate("/review_tax");
      }
      setIsSubmitLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsSubmitLoading(false);
    }
  };

  const forceCompleteTask = async () => {
    try {
      setIsForceCompleteLoading(true);
      const { data } = await ForceCompleteReviewTaxApi({ organizer_id: id });
      if (data?.status) {
        toast.success(data?.message);
        navigate("/review_tax");
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsForceCompleteLoading(false);
    }
  };

  const openInvoiceModal = async () => {
    try {
      setIsModalOpen(true);
      setIsLoadingInvoice(true);
      const { data } = await GetInvoiceListApi();
      if (data?.status) {
        setInvoiceOptions(
          data?.data?.map((item) => {
            return {
              value: item?.id,
              label: `${item?.name} - $${item?.amount}`,
            };
          })
        );
      }
      setIsLoadingInvoice(false);
    } catch (error) {
      setIsLoadingInvoice(false);
    }
  };

  const deleteInvoice = async () => {
    try {
      setIsInvoiceLoading(true);
      const params = {
        organizer_id: id,
      };
      const { data } = await DeleteInvoiceApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsInvoiceOpen(false);
        setClientData({ ...clientData, is_invoice_send: 0 });
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsInvoiceLoading(false);
    }
  };

  const sendInvoiceHandler = async (values) => {
    try {
      setIsLoadingSubmit(true);
      let params = { organizer_id: id, ...values };
      const { data } = await SendInvoiceApi(params);
      if (data?.status) {
        toast.success(data?.message);

        socket.emit(
          "updateTask",
          JSON.stringify({ task: 1, userId: clientData?.id })
        );
      }
      form.resetFields();
      setIsModalOpen(false);
      setIsLoadingSubmit(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsLoadingSubmit(false);
    }
  };
  return (
    <div className="mb-6">
      <div className="border-2 rounded-xl p-5">
        {isLoading ? (
          <div className="flex justify-center flex-col h-screen">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <>
            <div className="flex justify-between gap-5 mb-5">
              <div>
                {clientData?.user && (
                  <div className="flex items-center gap-3">
                    <p className="font-semibold text-xl capitalize">
                      {clientData?.user?.name}
                    </p>
                    <p
                      className="text-blue-500 underline cursor-pointer"
                      onClick={() => navigate(`/client/${clientData?.user_id}`)}
                    >
                      View
                    </p>
                  </div>
                )}
              </div>
              <div className="flex items-center gap-5">
                <div className="flex items-center gap-5">
                  {clientData?.auth_pdf?.url && (
                    <PdfLink
                      text={"Authorization"}
                      data={clientData?.auth_pdf}
                    />
                  )}
                  {clientData?.gst_pdf?.url && (
                    <PdfLink text={"GST"} data={clientData?.gst_pdf} />
                  )}
                </div>
                {clientData?.is_invoice_send ? (
                  <Button
                    type="primary"
                    className="uppercase font-semibold"
                    onClick={() => setIsInvoiceOpen(true)}
                  >
                    Delete Invoice
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    className="uppercase font-semibold"
                    onClick={openInvoiceModal}
                  >
                    Send Invoice
                  </Button>
                )}
              </div>
            </div>

            {data?.map((item, index) => (
              <div className="table-radius-0 text-light mb-10">
                <p className="font-semibold text-xl text-primary mb-5">
                  {`Section ${index + 1}:`} {item?.section_name}
                </p>
                <SkeletonTable
                  columns={columns}
                  data={item?.questions}
                  isLoading={isLoading}
                />
              </div>
            ))}

            <div className="flex gap-3">
              <LoadableButton
                className="bg-primary text-white uppercase text-base font-semibold py-2 rounded-lg px-4"
                type="button"
                lable="Complete Task"
                loadingLable="Completing Task..."
                isLoading={isSubmitLoading}
                onClick={completeTask}
              />

              <LoadableButton
                className="bg-primary text-white uppercase text-base font-semibold py-2 rounded-lg px-4"
                type="button"
                lable="Force Complete"
                loadingLable="Force Completing..."
                isLoading={isForceCompleteLoading}
                onClick={forceCompleteTask}
              />
            </div>
          </>
        )}
      </div>

      {/* Edit Answer */}
      <AnswerModal
        isOpen={isAnswerOpen}
        setIsOpen={setIsAnswerOpen}
        question={selectedQuestion}
        reloadQuestions={getAnswer}
      />

      {/* View Files */}
      <ViewFilesModal
        isOpen={isFilesOpen}
        setIsOpen={setIsFilesOpen}
        question={selectedQuestion}
      />

      {/* Delete Invoice */}
      <ConfirmationModal
        isOpen={isInvoiceOpen}
        setIsOpen={setIsInvoiceOpen}
        message="Are you sure, want to delete this invoice?"
        onConfirm={deleteInvoice}
        isLoading={isInvoiceLoading}
        loadingLabel="Deleting..."
      />

      <ModalComponent
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        title="Invoice"
      >
        {isLoadingInvoice ? (
          <div className="flex justify-center flex-col my-[10%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <Form
            autoComplete="off"
            form={form}
            initialValues={initialValues}
            onFinish={sendInvoiceHandler}
          >
            <Form.Item
              name="invoice_temp_id"
              rules={[
                { required: true, message: "Please select invoice type!" },
              ]}
            >
              <Select
                placeholder="Select Invoice"
                options={invoiceOptions}
                size="large"
              />
            </Form.Item>
            <div className="flex justify-center ">
              <LoadableButton
                className="bg-primary text-white uppercase text-base font-semibold w-full py-2 rounded-lg mt-2"
                type="submit"
                lable="Send Invoice"
                loadingLable="Sending Invoice..."
                isLoading={isLoadingSubmit}
              />
            </div>
          </Form>
        )}
      </ModalComponent>
    </div>
  );
}
